import { getPrintTypeApi, getPrintDefaultApi, editPrintDefaultApi, queryPrintRecord, printOrder, queryPrintClient, batchPrint, consumeMessage } from '@/api/print'
import _ from 'lodash'

class PrintDto {
    /**
     * 查询打印类型
     * @param {deptId} params 
     * @returns 
     */
    static getPrintType(obj) {
            return new Promise((resolve, reject) => {
                getPrintTypeApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 查询默认打印机
         * @param {deptId,printType} params 
         * @returns 
         */
    static getPrintDefault(obj) {
            return new Promise((resolve, reject) => {
                getPrintDefaultApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 编辑医馆和个人默认打印机
         * @param {deptId,printType,deptPrintDefault,userPrintDefault} params 
         * @returns 
         */
    static editPrintDefault(obj) {
            return new Promise((resolve, reject) => {
                editPrintDefaultApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 查询打印机列表
         * @param {} params 
         * @returns 
         */
    static getPrintClientList(obj) {
        return new Promise((resolve, reject) => {
            queryPrintClient(obj).then(res => {
                if (res.code == 200) {
                    res.data.forEach(val => {
                        val.printerInfos.forEach(k => {
                            k.id = val.clientId + k.printerName
                        })
                    })
                }
                resolve(res)
            }).catch(err => {
                reject([])
            })
        })
    }

    //打印订单
    static printOrder(obj) {
            return new Promise((resolve, reject) => {
                printOrder(obj).then(res => {
                    if (res.code == 200) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                }).catch(err => {
                    reject(false)
                })
            })
        }
        //计算默认打印机是否在打印机列表内
    static computeHasPrint(list, id) {
            return _.flatten(list.map(val => val.printerInfos.filter(k => k.id == id)))
        }
        //选择使用个人还是门店打印机
    static choosePrint() {}

    //批量打印订单
    static batchPrint(obj) {
            return new Promise((resolve, reject) => {
                batchPrint(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(false)
                })
            })
        }
        // 批量打印-获取打印进度
    static consumeMessage(obj) {
            return new Promise((resolve, reject) => {
                consumeMessage(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(false)
                })
            })
        }
        // 查询打印记录
    static queryPrintRecord(obj) {
        return new Promise((resolve, reject) => {
            queryPrintRecord(obj).then(res => {
                resolve(res)
            }).catch(err => {
                resolve({ code: 500 })
            })
        })
    }


}
export { PrintDto }